import { render, staticRenderFns } from "./p4s2BusinessInformation.vue?vue&type=template&id=95af1a16"
import script from "./p4s2BusinessInformation.vue?vue&type=script&lang=js"
export * from "./p4s2BusinessInformation.vue?vue&type=script&lang=js"
import style0 from "./p4s2BusinessInformation.vue?vue&type=style&index=0&id=95af1a16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports